import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const ListerCommoditer = () => async (dispatch) => {
  try {
    const response = await instance.get("commodites");
    console.log("REPONSECommodite", response);
    dispatch(fetchCommodite(response.data.data.map((item) => ({ ...item, checked: false, number: 0 }))));
  } catch (error) {
    console.log();
  }
};
// export const removeFlagReservation = (payload) => async (dispatch) => {
//   try {
//     const response = await instance.post("/updateFlagReservation/" + payload);
//     console.log("REPONSERECLAMATION", response);
//     if (response.status === true) {
//       dispatch(removeItem());
//     }
//   } catch (error) {
//     console.log();
//   }
// };
export const ProprieteReducer = createSlice({
  name: "Propriete",
  initialState: { commodite: null },
  reducers: {
    fetchCommodite: (state, action) => {
      state.commodite = action.payload;
    },
  },
});

export const { fetchCommodite } = ProprieteReducer.actions;
export default ProprieteReducer.reducer;
